import React, { useCallback, useState } from "react";
import { IUseWindowSize } from "@att-bit/duc.hooks.use-window-size";
import { GvpPlayer } from "@att-bit/gvp.components.gvp-player";

export interface BackgroundVideoProps {
  id: string;
  modal?: boolean;
  isScroll?: boolean;
  cinema?: boolean;
  autoplay?: boolean;
  autoPlayPause?: boolean;
  autoPlayLoop?: boolean;
  overlayTextDisplayAtEnd?: boolean;
  showTime?: boolean;
  showTitle?: boolean;
  videoStyles?: {height?:string, width?: string};
  autoReduceSize?: boolean;
  viewport?: IUseWindowSize;
  playerView?: boolean;
  parentCallback?: any;
  opacity?: string;
  showVideoPlayerAnalytics?: any;
  additionalAnalyticsData?: any;
  gvpPlayerAccessibilityText?: string;
  radius?: boolean;
  unconstrained?: boolean;
  viewportPause?: boolean;
  className?: string;
}

export const BackgroundVideo = ({
  id,
  isScroll,
  cinema,
  modal,
  autoplay,
  autoPlayPause,
  autoPlayLoop,
  playerView,
  videoStyles,
  viewport,
  overlayTextDisplayAtEnd,
  gvpPlayerAccessibilityText,
  showVideoPlayerAnalytics,
  additionalAnalyticsData,
  radius = false,
  unconstrained,
  viewportPause,
  className,
  ...props
}: BackgroundVideoProps) => {
  const [showVideoPlayer, SetShowVideoPlayer] = useState(true);
  const videoPlayerClose = useCallback(() => {
    const currentVideo = document.getElementById(
      `videoPlayer_playerView${id}`
    ) as HTMLMediaElement || document.getElementById(
      `videoPlayer_${id}`
    ) as HTMLMediaElement;
    if (currentVideo) {
      const currentTime = Math.round(currentVideo?.currentTime);
      const videoDuration = Math.round(currentVideo?.duration);
      if (currentTime === videoDuration) {
        if(props && props?.parentCallback){
          SetShowVideoPlayer(false);
          props && props?.parentCallback && props.parentCallback(false);
        }
        currentVideo.removeEventListener('timeupdate', videoPlayerClose);
      }
    }
  }, [id]);

  const setEvent = () => {
    const currentVideo = document.getElementById(
      `videoPlayer_playerView${id}`
    ) || document.getElementById(
      `videoPlayer_${id}`
    );
    if (currentVideo) {
      currentVideo.addEventListener('timeupdate', videoPlayerClose);
    }
  };
  if(typeof document !== "undefined"){
    if (!document?.getElementById(`videoPlayer_playerView${id}`)) {
      setTimeout(() => {
        setEvent();
      }, 4000);
    }
}
  return (
    <>
      {id && showVideoPlayer &&       
        <div id={`${id}-video`} aria-label={gvpPlayerAccessibilityText} className="width-full height-full">
          <GvpPlayer
            data={{ video: id }}
            radius={radius}
            options={{ isScroll: isScroll, 
              autoplay: autoplay, 
              autoPlayLoop: autoPlayLoop,
              autoPlayPause: autoPlayPause,
              cinema: cinema,
              unconstrained: unconstrained,
              viewportPause,
              modal: modal, 
              playerView: playerView,
              overlayTextDisplayAtEnd: overlayTextDisplayAtEnd,
              videoStyles: JSON.stringify(videoStyles)}}
              events={{...(showVideoPlayerAnalytics ? { closeGVPPlayerView: showVideoPlayerAnalytics }: {} )}}
              {...(additionalAnalyticsData && {
                additionalAnalyticsData: {...additionalAnalyticsData},
              })}
          />
       </div>
      }
    </>
  );
};
export default BackgroundVideo;
